import { Avatar } from 'features/Avatar/Avatar';
import { ParticipantPresenterProps } from 'features/ParticipantItem/types';
import { RaiseHandIcon } from 'features/RaiseHand';
import { useRaiseHand } from 'features/RaiseHand/hooks/useRaiseHand';
import { useSIPParticipant } from 'useCase/SIPTelephony/useSIPParticipant';
import { ParticipantBar } from '../../components/ParticipantBar';
import { SpeakerPlaceholder, SIPCallIcon } from './view';

interface Props extends ParticipantPresenterProps {}

export const SpeakerSIP = ({ isAudioMuted, participant, isShowPulseAnimation }: Props) => {
    const { getSIPParticipantName } = useSIPParticipant();
    const name = getSIPParticipantName(participant);

    const { checkIsHandRaised } = useRaiseHand();
    const handRaised = checkIsHandRaised(participant);

    return (
        <>
            <Avatar
                participant={participant}
                PresenterPlaceholder={SpeakerPlaceholder}
                isShowPulseAnimation={isShowPulseAnimation}
            >
                <SIPCallIcon icon="icCall" $speaker />
            </Avatar>

            <ParticipantBar isAudioMuted={isAudioMuted} name={name} />
            {handRaised && <RaiseHandIcon />}
        </>
    );
};
